import Attribute from './models/Attribute'
import { loadAttribute } from '@/api/environment'
import { groupBy } from 'lodash'

let attrModel = new Attribute();

export default {

  namespaced: true,

  state: {
    attribute: attrModel
  },

  mutations: {
    ...attrModel.mutations()
  },

  actions: {
    loadAttribute: ({ commit }, attributeId) => new Promise((resolve, reject) => {
      loadAttribute(attributeId, ({ data }) => {
        commit('setAttribute', data)
        resolve(data)
      }, error => reject(error))
    }),
  },

  getters: {
    attribute: state => state.attribute,
    findingsByCheckpoint: (state) => groupBy(state.attribute.findings, 'checkpoint.id')
  }

}